<template>
    
    
    <footer class="gd_footer clearfix">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 order-4 order-lg-1">
                    <img class="logo_footer" :src="baseHref+'assets/images/EDR_Logo-wht.png'" alt="">
                    <img class="logo_footer_2" :src="baseHref+'assets/images/Sponsor+01.png'" alt="">
                    <p>License #1062452 <br> © 2024 EDR Design Build. All rights reserved.</p>
                </div>
                <div class="col-lg-3 order-3 order-lg-2 footerContact">
                    <h4>Contact Us</h4>
                    <p class="pb-5"><a href="tel:(650) 888-2107">(650) 888-2107</a> <br><a href="mailto:info@edremodel.com">info@edremodel.com</a></p>
                    <h4>Our Office</h4>
                    <p>Los Gatos <br> 16185 Los Gatos Blvd, Suite #205, Los Gatos, CA 95032</p>
                    
                </div>
                <div class="col-lg-2 order-2 order-lg-3">
                    <h4>Useful Links</h4>
                    <ul class="footerLinks">
                        <li><router-link to="/your_orders">Your Orders </router-link></li>
                        <li><router-link to="/return_policy">Return Policy</router-link></li>
                        <li><router-link to="/faq">FAQ</router-link></li>
                        <li><router-link to="/contact">Wevisu Support</router-link></li>
                        <li><router-link to="/privacy_policy">Privacy Policy</router-link></li>
                        <li><router-link to="/cookies_policy">Cookies Policy </router-link></li>
                        <li><router-link to="/terms_of_service">Terms of Condition</router-link></li>
                    </ul>
                    <div class="p_by"><h4>Powered by </h4><a target="_blank" href="https://wevisu.com/"><img src="/assets/images/we_visu_2.png" alt=""></a></div>
                </div>
                
                <div class="col-lg-4 order-1 order-lg-4">
                    <ul class="socialLinks">
                        <li><a target="_blank" href="https://www.instagram.com/ed_remodel/"><i class="fa-brands fa-instagram"></i></a></li>
                        <li><a target="_blank" href="https://www.facebook.com/eddiedesignremodel"><i class="fa-brands fa-facebook-f"></i></a></li>
                        <li><a target="_blank" href="https://www.yelp.com/biz/eddie-design-and-remodeling-los-gatos-5"><i class="fa-brands fa-yelp"></i></a></li>
                        <li><a target="_blank" href="https://www.houzz.com/professionals/general-contractors/eddie-design-and-remodeling-pfvwus-pf~565935875"><i class="fa-brands fa-houzz"></i></a></li>
                        <li><a target="_blank" href="https://www.youtube.com/@eddiedesignremodeling2795"><i class="fa-brands fa-youtube"></i></a></li>
                    </ul>
                    
                    <img class="houzz_image" :src="baseHref+'assets/images/houzz.png'" alt="">
                </div>
            </div>
            
            
        </div>
        <!-- <div class="copyright_ftr">
            <div class="container">
                <div class="row pb-0">
                <div class="col-12 py-4">
                    <p><span>License Number: CSLB 1009639</span> <span>Copyright © 2024 Green Planet Restoration LA. All rights reserved.</span></p>
                </div>
            </div>
            </div>
        </div> -->
        
    </footer>
    
    
    
    
    <!-- <footer class="rc_footer clearfix">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <img class="logo_footer" :src="baseHref+'assets/images/logo-black.png'" alt="">
                    <ul class="footerSocial">
                        <li><a target="_blank" href="https://www.facebook.com/Royal-Construction-109444288049530"><i class="bi bi-facebook"></i></a></li>
                        <li><a target="_blank" href="https://www.instagram.com/royal_construction_inc/"><i class="bi bi-instagram"></i></a></li>
                        <li><a target="_blank" href="https://in.pinterest.com/RoyalFamilyConstructionInc/"><i class="bi bi-pinterest"></i></a></li>
                    </ul>
                    <p>At Royal Family Construction, Inc., we redefine luxury home transformations across the West Coast. As a leading modern company, our expertise lies in delivering high-end, sophisticated upgrades that elevate your living space to new heights. Our mission is to enhance lives one home at a time, making the construction process simple and exciting.</p>
                    <p>When renovating your home, trust is essential. We take pride in our honesty, integrity, and commitment to customer satisfaction. Treating you like family, we ensure open communication throughout, so you always feel like royalty in your home.</p>
                </div>
                <div class="col-md-3 ps-md-5" >
                    <h4>links</h4>
                    <ul class="footerLinks">
                        <li><router-link to="/your_orders">Your Orders </router-link></li>
                        <li><router-link to="/return_policy">Return Policy</router-link></li>
                        <li><router-link to="/faq">FAQ</router-link></li>
                        <li><router-link to="/contact">Wevisu Support</router-link></li>
                        <li><router-link to="/privacy_policy">Privacy Policy</router-link></li>
                        <li><router-link to="/cookies_policy">Cookies Policy </router-link></li>
                        <li><router-link to="/terms_of_service">Terms of Condition</router-link></li>
                    </ul>
                    <div class="p_by"><h4>Powered by </h4><a target="_blank" href="https://wevisu.com/"><img src="/showroom/assets/images/we_visu_3.png" alt=""></a></div>
                </div>
                <div class="col-md-4">
                    <h4>get in touch</h4>
                    <ul class="contactDtls">
                        <li><strong>Address:</strong> 15760 Ventura Blvd, Ste 620, Encino, CA 91436</li>
                        <li><strong>Phone:</strong> (818) 441-6705</li>
                        <li><strong>Email address:</strong> office@royal-construction.com</li>
                        <li><strong>CA License</strong> #1082702</li>
                        <li><strong>WA License</strong> #ROYALFC774KW</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footerCopyRt">
        <div class="container">
            <div class="row">
                <div class="col-md-6 order-2 order-md-1">
                    <p>&copy; 2024 all rights reserved to Royal Family Construction</p>
                </div>
                <div class="col-md-6 order-1 order-md-2">
                    <ul>
                        <li><a href="https://royal-construction.com/?page_id=3">Privacy policy</a></li>
                        <li><a href="https://royal-construction.com/?page_id=2">Terms of use</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="popupSideBottom">
        <div class="showPopupBtn">Save up to 30%</div>
        <button class="closeBtn">
            <i class="bi bi-x-lg"></i>
        </button>
        <div class="content">
            <h3>Save up to 30%</h3>
            <p>Limited-time offer on all finishing materials.</p>
            <form @submit.prevent="submit_query()">
                <input type="text" class="form-control" placeholder="Enter your name" v-model="form.full_name" v-validate="'required'" name="full_name" :class="{ 'is-invalid': verrors.has('full_name') }">
                <input type="text" class="form-control" placeholder="Enter your email address" v-model="form.email" v-validate="'required|email'" name="email" :class="{ 'is-invalid': verrors.has('email') }">
                <input type="text" class="form-control" placeholder="Enter your phone number" v-model="form.phone_number" v-validate="'required'" name="phone_number" :class="{ 'is-invalid': verrors.has('phone_number') }">
                <button class="btn btn-primary" type="submit">Send</button>
            </form>
           
        </div>
    </div>
    </footer> -->
    
    
    
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
export default {
    name: "Footer",
    data() {
        return {
            baseHref:baseHref,
            year: new Date().getFullYear(),
            is_valid_chat: false,
            form:{}
        };
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("Common", ["Setting"]),
        ...mapGetters({ 
            showroomId: "Common/MyItem", 
        }),
        ...mapGetters(["errors"]),
    },
    methods: {
        ...mapActions("Common", ["getSettingData"]),
        submit_query() {
            this.$validator.validateAll().then(async (valid) => {
                if (valid) {

                    let loader = this.$loading.show({ loader: 'dots' })
                    this.form.action = 'handle_external_form_submission'
                    var formData = new FormData();
                     
                    Object.entries(this.form).forEach(([key, value]) => {
                        formData.append(key, value);
                    });
                    

                    axios.post('https://royal-construction.com/wp-admin/admin-ajax.php', formData, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }})
                        .then((data) => {
                            loader.hide()
                            if (data.data.success) {
                                this.form = {};
                            }
                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });
                        })
                        .catch(err => {
                            loader.hide()
                        })

                }
            })
        },
    },

    created() {
        this.getSettingData()

    }

};
</script>


<style>
/* Override the default positioning of the toast */
.my-custom-toast-class {
        position: fixed !important; /* Ensure it's fixed relative to the viewport */
        bottom: 0 !important;       /* Align to the bottom of the viewport */
        left: 0 !important;         /* Align to the left of the viewport */
        margin: 16px !important;    /* Optional: add some margin from the edges */
        inset: 0 0 auto auto !important; /* Custom insets */
        background: #ffffff !important; /* Custom background color */
        color: white !important; /* Custom text color */
        z-index: 9999; /* Ensure it's on top */
        height: auto !important;
      }
      
      /* Optionally, remove any backdrop if SweetAlert2 uses it in modals */
      .swal2-container.swal2-top-end.swal2-backdrop-show.my-custom-toast-class {
         background: #ffffff !important;
      }
</style>
